// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderHistoryTableStyles } from "@eisinc/Overrides/Widgets/OrderHistory/OrderHistoryTable";
import ShoppingCart from "@eisinc/XDL/Icons/ShoppingCart";
import { css } from "styled-components";

orderHistoryTableStyles.noResultsContainer = {
    css: css`
        text-align: center;
        margin-top: 20px;
        padding-right: 10px;
    `,
};

orderHistoryTableStyles.reorderLink = {
    typographyProps: {
        size: "16px",
    },
    icon: {
        iconProps: {
            src: ShoppingCart,
            size: 18,
            color: "primary.main",
        },
        position: "left",
    },
};

orderHistoryTableStyles.reorderButtonSpinner = {
    color: "primary.main",
    size: 22,
    css: css`
        display: block;
        margin-left: 26px;
    `,
};

orderHistoryTableStyles.orderTotalCells = { alignX: "left" };

orderHistoryTableStyles.shipToHeader =
    orderHistoryTableStyles.orderTotalHeader =
    orderHistoryTableStyles.reorderHeader =
        { tight: false };
